import { useContext } from "react";
import { NavegationQuestionContext } from "../components/NavegationQuestionProvider";


export default function useNavigationQuestion() {
    const context = useContext(NavegationQuestionContext);

    if (!context) {
        throw new Error("useNavigationQuestion should be used within NavegationQuestionProvider");
    }

    return context;
}